import { createSelector } from '@reduxjs/toolkit';
import { getState } from '@yme/selectors/common';
export const getNewsletter = createSelector(getState, (state) => state.newsletter);
export const getNewsletterInterests = createSelector(getNewsletter, (state) => state.interests);
export const getNewsLetterIsLoading = createSelector(getNewsletter, (state) => state.isLoading);
